import "@/App.css";
import { useEffect, useState } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import axios from "axios";
import Lenis from "lenis";
import { Toaster } from "sonner";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import About from "@/components/About";
import TrackRecord from "@/components/TrackRecord";
import Expertise from "@/components/Expertise";
import Showcase from "@/components/Showcase";
import Publications from "@/components/Publications";
import Testimonials from "@/components/Testimonials";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";
import CustomCursor from "@/components/CustomCursor";
import AdminPage from "@/pages/AdminPage";
import ContentPage from "@/pages/ContentPage";
import VideoPostPage from "@/pages/VideoPostPage";

const Landing = () => {
  const [aiApps, setAiApps] = useState([]);
  const [businesses, setBusinesses] = useState([]);
  const [publications, setPublications] = useState([]);
  const [hasVideos, setHasVideos] = useState(false);

  useEffect(() => {
    const base = `${process.env.REACT_APP_BACKEND_URL}/api`;
    axios.get(`${base}/ai-apps`).then((r) => setAiApps(r.data)).catch(() => {});
    axios.get(`${base}/businesses`).then((r) => setBusinesses(r.data)).catch(() => {});
    axios.get(`${base}/publications`).then((r) => setPublications(r.data)).catch(() => {});
    axios.get(`${base}/videos`).then((r) => setHasVideos(r.data.length > 0)).catch(() => {});
  }, []);

  useEffect(() => {
    const lenis = new Lenis({ duration: 1.3, smoothWheel: true });
    const raf = (time) => {
      lenis.raf(time);
      requestAnimationFrame(raf);
    };
    requestAnimationFrame(raf);
    return () => lenis.destroy();
  }, []);

  return (
    <div className="relative bg-[#EFEAE1] text-[#121110] min-h-screen cursor-hidden">
      <CustomCursor />
      <Navbar hasApps={aiApps.length > 0} hasBusinesses={businesses.length > 0} hasPress={publications.length > 0} hasVideos={hasVideos} />
      <main>
        <Hero />
        <About />
        <TrackRecord />
        {businesses.length > 0 && (
          <Showcase
            items={businesses}
            id="businesses"
            testId="businesses-section"
            prefix="business"
            bg="bg-[#EFEAE1]"
            heading={<>BUSIN<span className="font-swash text-[#A8512E] text-[10vw] lg:text-[6vw]">e</span>SSES</>}
            blurb="The verticals I run today — built quietly, growing loudly. Click any of them to visit."
          />
        )}
        {aiApps.length > 0 && (
          <Showcase
            items={aiApps}
            id="ai-apps"
            testId="ai-apps-section"
            prefix="ai-app"
            bg="bg-[#E3DCCD]"
            heading={<>AI <span className="font-swash text-[#A8512E] text-[10vw] lg:text-[6vw]">a</span>PPS</>}
            blurb="Quiet experiments with loud potential — AI products I've built and shipped. Click any of them to try it yourself."
          />
        )}
        <Expertise />
        {publications.length > 0 && <Publications items={publications} />}
        <Testimonials />
        <Contact />
      </main>
      <Footer />
    </div>
  );
};

function App() {
  return (
    <BrowserRouter>
      <Toaster position="bottom-right" toastOptions={{ style: { background: "#121110", border: "1px solid #A8512E", color: "#EFEAE1", borderRadius: "999px" } }} />
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/content" element={<ContentPage />} />
        <Route path="/content/:videoId" element={<VideoPostPage />} />
        <Route path="/admin" element={<AdminPage />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
